import { themePageMutation, themesQuery, shopPlatformConnectMutation } from "./gql";
import store from "@/store";
import { INSTANT_API_DOMAIN } from "@/config";

/**
 * Onboarding init GemPages
 * appType= 'GEMPAGESV7' | 'GEMPAGES'
 * @returns bool
 */
export const initGemPages = async (appType = "GEMPAGESV7") => {
  const res = await fetch(`${INSTANT_API_DOMAIN}/init-app`, {
    method: "POST",
    credentials: "include", // include, *same-origin, omit
    body: JSON.stringify({
      appType: appType
    })
  });

  const resJson = await res.json();
  if ([200, 201].includes(res.status)) {
    return true;
  }
  if ([400].includes(res.status)) {
    if (resJson.code == 400102) {
      return true;
    }
  }

  throw new Error("Can't init gempages v5, " + JSON.stringify(resJson));
};

/**
 * Get information of shop with GemPages V7
 * @returns { data }
 */
export const getShopV7Api = async () => {
  return fetchShopLogin('gempagesv7')
};


export const fetchShopLogin = async (
  connectType,
  retries = 5,
) => {
  const urlPath = connectType == 'gempagesv7' ? 'shop-login/gempagesv7' : 'shop-login/gempages';
  const res = await fetch(`${INSTANT_API_DOMAIN}/${urlPath}`, {
    credentials: 'include', // include, *same-origin, omit
  });

  // System error
  if (res.status >= 500) {
    if (retries > 0) {
      await sleep(500 * (5 - retries + 1));
      return fetchShopLogin(connectType, retries - 1);
    }
    throw new Error(res.statusText);
  }

  const resJson = (await res.json());

  // GemPages api me error
  if (resJson.code == 500100) {
    if (retries > 0) {
      await sleep(500 * (5 - retries + 1));
      return fetchShopLogin(connectType, retries - 1);
    }
  }

  // Can't permission access
  if (res.status == 401 || resJson.code == 401101 || resJson.code == 400120 || resJson.code == 400126) {
    throw new Error(`Can't permission access, ${JSON.stringify(resJson), res.status}`);
  }

  return resJson;
};

const sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};


/**
 * Base api graphql query
 * @param {*} body
 * @returns
 */
export const instantBaseApi = async body => {
  const res = await fetch(`${INSTANT_API_DOMAIN}/graphql/query`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-GemX-Shop-ID": store.state.account.instantShopId,
      ...(store.state.account.instantShopToken && {
        Authorization: `Token ${store.state.account.instantShopToken}`
      })
    },
    ...(!store.state.account.instantShopToken && { credentials: "include" }),
    body
  });

  if (res.status >= 500) {
    throw new Error(res.statusText);
  }

  const resJson = await res.json();
  if ([200, 201].includes(res.status)) {
    return resJson;
  }

  throw new Error("Can't access instant");
};

/**
 * API get theme gempages v5
 * @returns
 */
export const getThemeApi = async () => {
  return await instantBaseApi(
    JSON.stringify({
      query: themesQuery,
      variables: {
        first: 1,
        where: {
          isPublished: true
        }
      }
    })
  );
};

/**
 * API create page with pageType
 * @param {*} themePage
 * @returns
 */
export const createThemePageApi = async themePage => {
  return await instantBaseApi(
    JSON.stringify({
      query: themePageMutation,
      variables: {
        input: themePage
      }
    })
  );
};

/**
 *
 */
export const connectPlatformV7 = async () => {
  return await instantBaseApi(
    JSON.stringify({
      query: shopPlatformConnectMutation,
      variables: {
        input: {
          appType: "GEMPAGESV7",
          platform: "SHOPIFY"
        }
      }
    })
  );
};
